module.exports = __webpack_public_path__ + "static/media/logo_dark.64753c85.png";